import _ from 'lodash';

function normalizeItem(bodyTypes) {
  return function (item) {
    var bodyTypeId = _.toString(item.bodyTypeId);
    var bodyType = _.find(bodyTypes, { id: +bodyTypeId });

    return {
      axleRatio: item.axleRatio,
      transmission: item.transmission,
      driveType: item.driveType,
      styleId: item.styleId,
      bodyTypeId: bodyTypeId,
      engine: item.engine,
      trimName: item.trimName || '',
      rearWheelType: bodyType.rearWheelType || '',
    };
  };
}

export default function normalizeModelMatrix(data, config) {
  return _.map(
    _.flatten(_.flatMap(_.values(data.table), _.values)),
    normalizeItem(config.bodyTypes)
  );
}
